/* ARCEE Heaven – Global JavaScript */
'use strict';

// ---- Header scroll effect ----
const header = document.querySelector('.header');
if (header) {
  window.addEventListener('scroll', () => {
    header.classList.toggle('is-scrolled', window.scrollY > 10);
  }, { passive: true });
}

// ---- Hell/Dunkel ----
// Das Attribut steht schon vom Inline-Skript im <head>; hier hängt nur die
// Bedienung dran. Ohne gespeicherte Wahl folgt der Shop weiter dem System.
(() => {
  const root = document.documentElement;
  const media = window.matchMedia('(prefers-color-scheme: dark)');
  const metaThemeColor = document.querySelector('[data-theme-color]');
  const paint = { light: '#ffffff', dark: '#12100f' };

  const read = () => {
    try {
      const stored = localStorage.getItem('theme');
      return stored === 'dark' || stored === 'light' ? stored : null;
    } catch (e) {
      return null;
    }
  };

  const apply = (theme) => {
    root.setAttribute('data-theme', theme);
    if (metaThemeColor) metaThemeColor.setAttribute('content', paint[theme]);
    document.querySelectorAll('[data-theme-toggle]').forEach((btn) => {
      btn.setAttribute('aria-pressed', String(theme === 'dark'));
    });
  };

  // Das Inline-Skript hat den Modus bereits bestimmt — hier nur übernehmen,
  // sonst würde ein im Editor erzwungener Startmodus wieder überschrieben.
  apply(read() || root.getAttribute('data-theme') || (media.matches ? 'dark' : 'light'));

  document.querySelectorAll('[data-theme-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const next = root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
      apply(next);
      try {
        localStorage.setItem('theme', next);
      } catch (e) {
        /* Ohne Speicher gilt die Wahl nur für diese Seite. */
      }
    });
  });

  // Systemwechsel nur übernehmen, solange niemand selbst gewählt hat und der
  // Shop nicht auf einen festen Startmodus eingestellt ist.
  media.addEventListener('change', (event) => {
    const forced = root.getAttribute('data-theme-default');
    if (!read() && forced !== 'light' && forced !== 'dark') {
      apply(event.matches ? 'dark' : 'light');
    }
  });
})();

document.querySelectorAll('[data-hero]').forEach((hero) => {
  // small delay so first paint is clean, then stamp everything on
  requestAnimationFrame(() => {
    setTimeout(() => hero.classList.add('is-printed'), 80);
  });
});

// ---- Product Tabs ----
document.querySelectorAll('.product-tabs__tab').forEach(tab => {
  tab.addEventListener('click', () => {
    const target = tab.dataset.tab;
    const container = tab.closest('.product-tabs');
    container.querySelectorAll('.product-tabs__tab').forEach(t => t.classList.remove('active'));
    container.querySelectorAll('.product-tabs__panel').forEach(p => p.classList.remove('active'));
    tab.classList.add('active');
    container.querySelector(`[data-panel="${target}"]`).classList.add('active');
  });
});

// ---- Product Image Gallery ----
document.querySelectorAll('.product-media__thumb').forEach(thumb => {
  thumb.addEventListener('click', () => {
    const gallery = thumb.closest('.product-media');
    const mainImg = gallery.querySelector('.product-media__main img');
    if (mainImg && thumb.dataset.src) {
      mainImg.src = thumb.dataset.src;
      gallery.querySelectorAll('.product-media__thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    }
  });
});

// ---- Variant Selection ----
// Reads the variant table the section printed and keeps id, price, availability
// and the stock meter in sync with the buttons.
(function initVariants() {
  const dataEl = document.querySelector('[data-variant-data]');
  const form = document.getElementById('product-form');
  if (!dataEl || !form) return;

  let variants = [];
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

  const idInput = form.querySelector('[name="id"]');
  const submit = form.querySelector('.product-submit');
  const priceEl = document.querySelector('.product-info__price > span:first-child');
  const stickyPrice = document.querySelector('[data-sticky-price]');
  const meter = document.querySelector('[data-stock-meter]');

  function selectedOptions() {
    const chosen = [];
    document.querySelectorAll('.product-option').forEach(opt => {
      const active = opt.querySelector('.product-option__value.active');
      if (active) chosen[parseInt(active.dataset.optionPosition, 10) - 1] = active.dataset.optionValue;
    });
    return chosen;
  }

  function update() {
    const chosen = selectedOptions();
    const match = variants.find(v => v.options.every((o, i) => o === chosen[i]));
    if (!match) return;

    idInput.value = match.id;
    if (priceEl) priceEl.textContent = match.price_formatted;
    if (stickyPrice) stickyPrice.textContent = match.price_formatted;

    if (submit) {
      submit.disabled = !match.available;
      submit.textContent = match.available ? submit.dataset.labelAvailable : 'Ausverkauft';
    }

    if (meter) {
      const low = parseInt(meter.dataset.lowThreshold, 10) || 25;
      const qty = match.inventory_quantity;
      const tracked = match.inventory_managed !== '' && match.inventory_managed !== null;
      const show = tracked && qty > 0 && qty <= low;
      meter.hidden = !show;
      if (show) {
        meter.querySelector('[data-stock-text]').textContent = `Nur noch ${qty} auf Lager`;
        meter.querySelector('.stock-meter-fill').style.width = Math.min(100, Math.round((qty / low) * 100)) + '%';
      }
    }

    // Keep the URL shareable without reloading the page.
    const url = new URL(window.location);
    url.searchParams.set('variant', match.id);
    window.history.replaceState({}, '', url);
  }

  if (submit) submit.dataset.labelAvailable = submit.textContent.trim();

  document.querySelectorAll('.product-option__value').forEach(val => {
    val.addEventListener('click', () => {
      const group = val.closest('.product-option__values');
      group.querySelectorAll('.product-option__value').forEach(v => v.classList.remove('active'));
      val.classList.add('active');
      update();
    });
  });
})();

// ---- Smooth scroll for anchor links ----
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', e => {
    const target = document.querySelector(anchor.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});

// ---- Age Gate (if present) ----
const ageGate = document.getElementById('age-gate');
const ageGateForm = document.getElementById('age-gate-form');
if (ageGate && ageGateForm) {
  const verified = sessionStorage.getItem('arcee_age_verified');
  if (!verified) {
    ageGate.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }
  ageGateForm.addEventListener('submit', e => {
    e.preventDefault();
    const ack1 = document.getElementById('ack-age');
    const ack2 = document.getElementById('ack-research');
    if (ack1 && ack1.checked && ack2 && ack2.checked) {
      sessionStorage.setItem('arcee_age_verified', '1');
      ageGate.style.display = 'none';
      document.body.style.overflow = '';
    }
  });
}

/* ============================================================
   CART — slide-out drawer, no page reload anywhere
   ============================================================ */
const FREE_SHIPPING_FALLBACK = 12000; // cents; the drawer carries the real value

function formatMoney(cents) {
  return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
}

const drawer = document.querySelector('[data-cart-drawer]');
const drawerOverlay = document.querySelector('[data-cart-overlay]');
let lastFocused = null;

function openCart() {
  if (!drawer) return;
  lastFocused = document.activeElement;
  drawerOverlay.hidden = false;
  requestAnimationFrame(() => {
    drawer.classList.add('is-open');
    drawerOverlay.classList.add('is-open');
  });
  drawer.setAttribute('aria-hidden', 'false');
  document.body.classList.add('drawer-open');
  drawer.querySelector('[data-cart-close]')?.focus();
}

function closeCart() {
  if (!drawer) return;
  drawer.classList.remove('is-open');
  drawerOverlay.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('drawer-open');
  setTimeout(() => { drawerOverlay.hidden = true; }, 280);
  lastFocused?.focus();
}

// Repaints every cart-dependent piece of UI from one /cart.js payload.
function refreshCartUI(cart) {
  document.querySelectorAll('.header__cart').forEach(el => {
    // Only swap the count node — replacing textContent would delete the icon markup.
    const count = el.querySelector('.header__cart-count');
    if (count) count.textContent = cart.item_count;
    el.setAttribute('aria-label', `Warenkorb, ${cart.item_count} Artikel`);
    el.classList.add('is-bumped');
    setTimeout(() => el.classList.remove('is-bumped'), 500);
  });

  document.querySelectorAll('.ship-bar').forEach(bar => {
    const threshold = parseInt(bar.dataset.shipThreshold, 10) || FREE_SHIPPING_FALLBACK;
    const remaining = threshold - cart.total_price;
    const text = bar.querySelector('.ship-bar__text');
    const fill = bar.querySelector('.ship-bar__fill');
    if (text) {
      text.innerHTML = remaining > 0
        ? `Nur noch <strong>${formatMoney(remaining)}</strong> bis zum Gratisversand.`
        : '<strong>Gratisversand freigeschaltet.</strong> Dein Paket geht kostenlos raus.';
    }
    if (fill) fill.style.width = Math.min(100, Math.round((cart.total_price / threshold) * 100)) + '%';
  });

  renderDrawer(cart);
}

function renderDrawer(cart) {
  if (!drawer) return;

  drawer.querySelector('[data-cart-count]').textContent = `(${cart.item_count})`;
  drawer.querySelector('[data-cart-total]').textContent = formatMoney(cart.total_price);
  drawer.querySelector('[data-cart-foot]').hidden = cart.item_count === 0;

  const body = drawer.querySelector('[data-cart-body]');
  if (cart.item_count === 0) {
    body.innerHTML =
      '<div class="drawer__empty"><p>Dein Warenkorb ist noch leer.</p>' +
      '<a href="/collections/all" class="button button--primary">Zum Shop</a></div>';
    return;
  }

  body.innerHTML = '<ul class="drawer__items">' + cart.items.map(item => `
    <li class="drawer-item" data-key="${item.key}">
      <a href="${item.url}" class="drawer-item__img">
        ${item.image ? `<img src="${item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')}" alt="" width="72" height="72" loading="lazy">` : ''}
      </a>
      <div class="drawer-item__info">
        <a href="${item.url}" class="drawer-item__title">${item.product_title}</a>
        ${item.variant_title ? `<div class="drawer-item__variant">${item.variant_title}</div>` : ''}
        <div class="drawer-item__price">${formatMoney(item.final_line_price)}</div>
        <div class="drawer-item__controls">
          <button type="button" class="qty-btn" data-cart-minus aria-label="Menge verringern">−</button>
          <span class="qty-val" data-cart-qty>${item.quantity}</span>
          <button type="button" class="qty-btn" data-cart-plus aria-label="Menge erhöhen">+</button>
          <button type="button" class="drawer-item__remove" data-cart-remove>Entfernen</button>
        </div>
      </div>
    </li>`).join('') + '</ul>';
}

async function changeLine(key, quantity, row) {
  row?.classList.add('is-busy');
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    if (!res.ok) throw new Error('change failed');
    refreshCartUI(await res.json());
  } catch (err) {
    row?.classList.remove('is-busy');
  }
}

// One delegated listener survives every re-render of the drawer contents.
drawer?.addEventListener('click', (e) => {
  const row = e.target.closest('.drawer-item');
  if (!row) return;
  const key = row.dataset.key;
  const qty = parseInt(row.querySelector('[data-cart-qty]').textContent, 10);

  if (e.target.closest('[data-cart-plus]')) changeLine(key, qty + 1, row);
  else if (e.target.closest('[data-cart-minus]')) changeLine(key, Math.max(0, qty - 1), row);
  else if (e.target.closest('[data-cart-remove]')) changeLine(key, 0, row);
});

drawer?.querySelector('[data-cart-close]')?.addEventListener('click', closeCart);
drawerOverlay?.addEventListener('click', closeCart);
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && drawer?.classList.contains('is-open')) closeCart();
});

// The header cart opens the drawer; the href stays as the no-JS fallback.
document.querySelectorAll('.header__cart').forEach(el => {
  el.addEventListener('click', (e) => {
    if (!drawer) return;
    e.preventDefault();
    openCart();
  });
});

async function addToCart(btn, form) {
  // Honour the form's own validation — the age/research checkbox must not be bypassed.
  if (form.reportValidity && !form.reportValidity()) return;

  const variantId = form.querySelector('[name="id"]')?.value;
  const quantity = form.querySelector('[name="quantity"]')?.value || 1;
  if (!variantId) return;

  const original = btn.textContent;
  btn.disabled = true;
  btn.textContent = 'Wird hinzugefügt…';
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: parseInt(quantity, 10) })
    });
    if (!res.ok) throw new Error('add failed');
    refreshCartUI(await (await fetch('/cart.js')).json());
    openCart();
    btn.disabled = false;
    btn.textContent = original;
  } catch (err) {
    btn.disabled = false;
    btn.textContent = original;
    form.submit(); // fall back to the normal POST so the customer is never stuck
  }
}

document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
  btn.addEventListener('click', (e) => {
    const form = btn.closest('form');
    if (!form) return;
    e.preventDefault(); // otherwise the native submit fires alongside the fetch
    addToCart(btn, form);
  });
});

// Sticky bar reuses the main form so validation and variant stay in sync.
document.querySelectorAll('[data-sticky-add]').forEach(btn => {
  btn.addEventListener('click', () => {
    const form = document.getElementById('product-form');
    if (form) addToCart(btn, form);
  });
});

// Cross-sell adds its own product, not the one on the page.
document.querySelectorAll('[data-upsell-add]').forEach(btn => {
  btn.addEventListener('click', async () => {
    const variantId = btn.dataset.variantId;
    if (!variantId) return;
    const original = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (!res.ok) throw new Error('add failed');
      refreshCartUI(await (await fetch('/cart.js')).json());
      openCart();
    } catch (err) {
      btn.textContent = 'Fehler';
    }
    setTimeout(() => { btn.disabled = false; btn.textContent = original; }, 1200);
  });
});

// ---- Lazy loading images ----
if ('IntersectionObserver' in window) {
  const imgObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        if (img.dataset.src) {
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
          imgObserver.unobserve(img);
        }
      }
    });
  }, { rootMargin: '200px' });
  document.querySelectorAll('img[data-src]').forEach(img => imgObserver.observe(img));
}

/* ============================================================
   Conversion + motion layer
   ============================================================ */
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

document.addEventListener('DOMContentLoaded', () => {

  /* ---- Scroll reveal --------------------------------------------------- */
  if ('IntersectionObserver' in window && !reducedMotion) {
    document.documentElement.classList.add('js-reveal');
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    // Anything worth animating in, without asking every section to opt in by hand.
    const revealTargets = '.reveal, .trust-item, .cat-card, .bt-card, .trust-signals__item, .article-card, .stat-item, .newsletter__inner, .final-cta, .coa-inner, .product-card';
    document.querySelectorAll(revealTargets).forEach((el, i) => {
      el.classList.add('reveal');
      if (!el.style.transitionDelay) el.style.transitionDelay = (i % 4) * 70 + 'ms';
      revealObserver.observe(el);
    });
  }

  /* ---- Live viewer counter --------------------------------------------
     Cosmetic drift around a starting number. It is not a real measurement —
     swap the source or drop the element if you want only verified figures.  */
  const viewerCount = document.querySelector('.live-viewers-count');
  if (viewerCount) {
    setInterval(() => {
      const current = parseInt(viewerCount.textContent, 10) || 20;
      const next = Math.max(9, Math.min(48, current + (Math.floor(Math.random() * 5) - 2)));
      viewerCount.textContent = next;
    }, 6000);
  }

  /* ---- Stock meter: animate to the real inventory percentage ----------- */
  document.querySelectorAll('.stock-meter-fill').forEach(fill => {
    const target = fill.dataset.stock || '0';
    requestAnimationFrame(() => { fill.style.width = Math.min(100, parseInt(target, 10)) + '%'; });
  });

  /* ---- Free shipping bar: paint the server-rendered value --------------- */
  document.querySelectorAll('.ship-bar__fill').forEach(fill => {
    const target = fill.dataset.shipFill || '0';
    requestAnimationFrame(() => { fill.style.width = Math.min(100, parseInt(target, 10)) + '%'; });
  });

  /* ---- Dispatch countdown ----------------------------------------------
     Counts to the next cut-off on a weekday (Mon–Fri), in German time
     whatever the visitor's clock says: before the cut-off "noch heute",
     after it the next weekday's cut-off ("morgen", or "am Montag" over the
     weekend). Public holidays are not known here.                          */
  const cutoff = document.querySelector('.cutoff');
  if (cutoff) {
    const cutoffHour = parseInt(cutoff.dataset.cutoffHour, 10) || 14;
    const timeEl = cutoff.querySelector('.cutoff__time');
    const afterEl = cutoff.querySelector('.cutoff__after');
    const textToday = afterEl.textContent;
    const textTomorrow = cutoff.dataset.textTomorrow || 'und wir versenden morgen.';
    const textLater = cutoff.dataset.textLater || 'und wir versenden am [tag].';
    const weekdays = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];

    // Wall-clock time in Berlin as a plain Date, so date maths below works
    // in German days and hours (DST shifts are off by an hour at most twice
    // a year, which a countdown can live with).
    const berlinFormat = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Berlin', hourCycle: 'h23',
      year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
    });
    const berlinNow = () => {
      const p = Object.fromEntries(berlinFormat.formatToParts(new Date()).map(({ type, value }) => [type, value]));
      return new Date(+p.year, p.month - 1, +p.day, +p.hour, +p.minute, +p.second);
    };

    const tick = () => {
      const now = berlinNow();
      const deadline = new Date(now);
      deadline.setHours(cutoffHour, 0, 0, 0);
      let daysAhead = 0;
      while (deadline <= now || deadline.getDay() === 0 || deadline.getDay() === 6) {
        deadline.setDate(deadline.getDate() + 1);
        daysAhead++;
      }

      afterEl.textContent = daysAhead === 0 ? textToday
        : daysAhead === 1 ? textTomorrow
        : textLater.replace('[tag]', weekdays[deadline.getDay()]);

      // Days only from 48 h on; "1 Tg. 0 Std." reads worse than "24 Std.".
      const diff = deadline - now;
      const hours = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      timeEl.textContent = hours >= 48 ? `${Math.floor(hours / 24)} Tg. ${hours % 24} Std.`
        : hours > 0 ? `${hours} Std. ${m} Min.`
        : `${m} Min. ${s} Sek.`;
      cutoff.hidden = false;
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ---- Sticky add-to-cart ---------------------------------------------- */
  const stickyAtc = document.querySelector('.sticky-atc');
  const mainAtc = document.querySelector('.product-submit');
  if (stickyAtc && mainAtc) {
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyAtc.classList.toggle('visible', show);
        stickyAtc.setAttribute('aria-hidden', show ? 'false' : 'true');
      }, { threshold: 0 }).observe(mainAtc);
    } else {
      window.addEventListener('scroll', () => {
        stickyAtc.classList.toggle('visible', mainAtc.getBoundingClientRect().bottom < 0);
      }, { passive: true });
    }
  }

  /* ---- Ticker: clone the track so the loop has no visible seam ---------- */
  document.querySelectorAll('[data-ticker-track]').forEach(track => {
    track.innerHTML += track.innerHTML;
    track.setAttribute('aria-hidden', 'false');
  });
});
